export default "__VITE_ASSET__BW91y5GJ__"